import React from "react";

interface CustomFileInputProps {
  id: string;
  className?: string;
  accept?: string;
  multiple?: boolean;
  capture?: boolean | "user" | "environment";
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CustomFileInput: React.FC<CustomFileInputProps> = ({
  id,
  className,
  accept,
  multiple = false,
  capture,
  onChange,
}) => {
  return (
    <input
      id={id}
      type="file"
      className={`form-control ${className || ""}`}
      accept={accept}
      capture={capture}
      multiple={multiple}
      onChange={onChange}
    />
  );
};

export default CustomFileInput;